import script from "./AccountVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountVerification.vue?vue&type=script&setup=true&lang=js"

import "./AccountVerification.vue?vue&type=style&index=0&id=3e8a0653&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e8a0653"]])

export default __exports__